'use client'; // Error components must be Client Components

import { useEffect } from 'react';
import { Button } from '@/components/ui/button'; // Assuming Button component exists

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 space-y-4">
      <h2 className="text-h2 text-destructive">Something went wrong!</h2>
      <p className="text-body text-center max-w-md">
        An unexpected error occurred. You can try reloading the page or contact support if the problem persists.
      </p>
      <p className="text-body-sm text-muted-foreground">
        Error details (for debugging): {error.message}
      </p>
      <Button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </Button>
    </div>
  );
} 